/* eslint-disable no-undef */
if (window.__POWERED_BY_QIANKUN__) {
  if (process.env.NODE_ENV === 'development') {
    __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
    console.log('test: ', __webpack_public_path__);
  }
}
